/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IButtonStyles } from '@fluentui/react/lib/Button';
import { IIconStyles } from '@fluentui/react/lib/Icon';
import { IStackStyles, IStackTokens } from '@fluentui/react/lib/Stack';
import { DarkColors } from '@msteams/components-fabric-teams-theme/dist/commonjs/src/teams/TeamsColors';
import { CSSProperties } from 'react';
import { Theme } from '../../../common/enums/Theme';
import { CoreColors, FontSizes } from '../../../styles/teams';
import { MOBILE_FONT_SIZE } from '../../../utilities/FontUtils';
import { getAppHost } from '../../../utilities/TeamsUtils';

export const stackTokens: IStackTokens = { padding: '0.7rem' };

export const containerStyle = (): CSSProperties => {
    const host = getAppHost();
    const theme = host.getTheme();
    const borderColor = theme === Theme.Dark ? DarkColors.appGray06 : CoreColors.appGray08;
    const darkColor = host.isIOS() ? CoreColors.appBlack04 : CoreColors.appBlack05;
    const backgroundColor = theme === Theme.Default ? CoreColors.appWhite : darkColor;

    return {
        backgroundColor,
        borderBottomColor: borderColor,
        borderTopColor: borderColor,
        borderBottomWidth: '1.0px',
    };
};

export const stackStyles: IStackStyles = {
    root: {
        width: '100%',
    },
};

export const actionButtonStyles: IButtonStyles = {
    root: {
        fontSize: MOBILE_FONT_SIZE,
    },
};

export const chevronIconStyles: IIconStyles = {
    root: {
        fontSize: FontSizes.size20,
    },
};
